import ButtonSection, { ButtonSectionProps } from './ButtonSection';

export type { ButtonSectionProps };
export default ButtonSection;
